<template>
  <div class="paillier-wrapper">
    <div class="paillier-des">
      <div class="decoration left top"></div>
      <div class="decoration right top"></div>
      <div class="decoration left bottom"></div>
      <div class="decoration right bottom"></div>
      <div class="large-icon"></div>
      <div class="content">
        <div class="title-bar">
          <div class="title">同态加密说明</div>
          <div class="hint">
            <span class="el-icon-warning-outline"></span
            >&nbsp;本算法明文、密文数据均需要使用小于2的64次方的非负整数
          </div>
          <div class="fill"></div>
          <instruction-btn
            :id="instruction.excellent.paillier.id"
            :instruction-info="instruction.excellent.paillier.instructionInfo"
            tool-tip-placement="left"
          ></instruction-btn>
        </div>
        <div class="describe">
          Paillier算法是公钥加密体系的一个代表算法。但是，不同于传统的公钥加密算法，Paillier
          算法除了实现对数据的公钥加密，还能保证在密文上直接进行加法操作，其结果解密后与在明文上进行操作的结果一样，因此Paillier算法完全的满足密文的加法同态性。除此之外，Paillier算法还支持明文和密文的乘法操作，具有良好的同态性，相比于当前的其他同态加密更加实用。
        </div>
        <div class="instruction-des">
          使用方法：请先在区块链部署同态加密智能合约，生成密钥后即可使用该加解密工具。
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" :tab-position="tabPosition">
      <el-tab-pane label="生成个人密钥" name="generateKey">
        <el-alert
          title="生成用于进行同态计算的公私钥，需要由用户妥善保管"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <generateKey v-if="activeName == 'generateKey'" ref="generateKey"></generateKey>
      </el-tab-pane>
      <el-tab-pane label="链上余额加密" name="chainEncrypt">
        <el-alert
          title="用户输入余额进行链上加密计算，加密后的数据在区块链中以密文形式存储，持有私钥方可解密"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <chainEncrypt v-if="activeName == 'chainEncrypt'" ref="chainEncrypt"></chainEncrypt>
      </el-tab-pane>
      <el-tab-pane label="链上余额解密" name="chainDecrypt">
        <el-alert
          title="用户选择上次加密的计算方式，获得链上加密计算后的解密结果"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <chainDecrypt v-if="activeName == 'chainDecrypt'" ref="chainDecrypt"></chainDecrypt>
      </el-tab-pane>
      <el-tab-pane label="本地加密" name="localEncryption">
        <el-alert title="用户可以在本地对数据进行加密" type="info" show-icon :closable="false">
        </el-alert>
        <localEncryption
          v-if="activeName == 'localEncryption'"
          ref="localEncryption"
        ></localEncryption>
      </el-tab-pane>
      <el-tab-pane label="本地解密" name="localDecryption">
        <el-alert
          title="用户可以在本地对数据进行解密，可以验证链上加密计算的结果"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <localDecryption
          v-if="activeName == 'localDecryption'"
          ref="localDecryption"
        ></localDecryption>
      </el-tab-pane>
    </el-tabs>

    <contractDetail ref="contractDetail"></contractDetail>
  </div>
</template>
<script>
import instruction from '@/instruction/index'
import contractDetail from './contractDetail'
import generateKey from './generateKey'
import localEncryption from './localEncryption'
import localDecryption from './localDecryption'

import chainEncrypt from './chainEncrypt'
import chainDecrypt from './chainDecrypt'

export default {
  name: 'Index',
  components: {
    contractDetail,
    generateKey,
    localEncryption,
    localDecryption,
    chainEncrypt,
    chainDecrypt
  },
  data() {
    return {
      info: 'describe',
      activeName: 'generateKey',
      tabPosition: 'top',
      instruction,
      chainId: ''
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
        this.getContractDetact()
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    //this.getContractDetact()
  },
  methods: {
    getContractDetact() {
      let params = {
        chainid: this.chainId
      }
      this.$apis.encryption.contractDetact(params).then(res => {
        if (res.errors[0].code == 40011) {
          this.$refs.contractDetail?.handleOpen(res.data)
          console.log(this.$refs)
        }
      })
    },

    refresh() {
      this.getContractDetact()
    },

    freeze(row) {
      this.$prompt('请输入冻结原因', '冻结合约', {
        confirmButtonText: '冻结',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入原因'
      })
        .then(({ value }) => {
          this.freezeForm.chainId = this.chainId
          this.freezeForm.ContractName = row.name
          this.freezeForm.reason = value
          this.$apis.chain.freezeContract(this.freezeForm).then(res => {
            this.$message({
              type: 'success',
              message: `${row.name}合约冻结开始投票`
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    logout(row) {
      this.$prompt('请输入注销原因', '注销合约', {
        confirmButtonText: '注销',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入原因'
      })
        .then(({ value }) => {
          this.logoutForm.chainId = this.chainId
          this.logoutForm.ContractName = row.name
          this.logoutForm.reason = value
          this.$apis.chain.revokeContract(this.logoutForm).then(res => {
            this.$message({
              type: 'success',
              message: '注销成功'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.paillier-wrapper {
  @include adaptation(
    (
      --common-gap-4: 4px,
      --common-gap-8: 8px,
      --common-gap-12: 12px,
      --common-gap-16: 16px,
      --common-gap-32: 32px,
      --common-gap-56: 56px,
      --common-pos-neg-offset: -1.5px,
      --decoration-border-width: 3px,
      --decoration-width: 32px,
      --decoration-height: 28px,
      --large-icon-width: 137px,
      --large-icon-height: 137px,
      --title-bar-height: 26px,
      --title-hint-line-height: 20px
    )
  );
  .paillier-des {
    color: var(--base-color-text-primary);
    background-color: var(--base-background-color-light);
    border: var(--base-border-width) solid var(--base-border-color-light);
    padding: var(--common-gap-16) var(--common-gap-56) var(--common-gap-16) var(--common-gap-32);
    position: relative;
    display: flex;
    align-items: center;

    .decoration {
      border: var(--decoration-border-width) solid transparent;
      position: absolute;
      width: var(--decoration-width);
      height: var(--decoration-height);
      &.left {
        left: var(--common-pos-neg-offset);
        border-left-color: var(--base-color-notice);
      }

      &.top {
        top: var(--common-pos-neg-offset);
        border-top-color: var(--base-color-notice);
      }

      &.right {
        right: var(--common-pos-neg-offset);
        border-right-color: var(--base-color-notice);
      }

      &.bottom {
        bottom: var(--common-pos-neg-offset);
        border-bottom-color: var(--base-color-notice);
      }
    }

    .large-icon {
      background-image: url('~@/assets/images/excellent/paillier-large-icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      min-width: var(--large-icon-width);
      margin-right: var(--common-gap-32);
      height: var(--large-icon-height);
    }

    .content {
      align-self: flex-start;
      margin-top: var(--common-gap-8);
      display: flex;
      flex-direction: column;
      height: calc(var(--large-icon-height) - var(--common-gap-8));

      .title-bar {
        display: flex;
        align-items: center;
        height: var(--title-bar-height);
        line-height: var(--title-bar-height);
        margin-bottom: var(--common-gap-16);

        .title {
          margin-right: var(--common-gap-16);
          font-weight: 700;
          font-size: var(--base-font-size-extra-large);
        }

        .fill {
          flex-grow: 1;
        }

        .hint {
          color: var(--base-color-notice-light-2);
          align-self: flex-end;
          line-height: var(--title-hint-line-height);
        }
      }

      .describe {
        color: var(--base-color-text-regular);
        flex-grow: 1;
      }

      .instruction-des {
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: var(--common-gap-4);
          height: var(--common-gap-4);
          margin-right: var(--common-gap-4);
          border-radius: 50%;
          background-color: var(--base-color-notice-light-2);
        }
      }
    }
  }

  .el-alert {
    margin-bottom: var(--common-gap-16);
  }
}
</style>
